<template>
  <transition v-if="isDisplay()" name="fade">
    <div class="fixed-button">
      <a
        :href="facilityDetail.facility.url"
        @click="
          handleAnalyticsTrackEvent(
            'facility_detail',
            'click',
            'official_link',
            1
          )
        "
        target="_blank"
      >
        {{ name }}
      </a>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import { config } from '@/utils/config'
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dataScrollY: {
        type: Number,
        default: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      facilityDetail: 'middle_page/detail'
    })
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  /* istanbul ignore next */
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      // スクロール位置をセット
      this.dataScrollY = window.pageYOffset
    },
    isDisplay() {
      return (
        this.facilityDetail.facility.url &&
        this.dataScrollY > config.fixedFooterPageYOffset
      )
    }
  }
}
</script>
